import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import router from '../main.js'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.baseURL = 'https://mr.summary88.com/';
//axios.defaults.baseURL = 'http://192.168.0.50/mrol/public/';

axios.interceptors.request.use((config) => {
	let token = Vue.prototype.getCookie('token');
	if(token && token != undefined && token != 'undefined') {
		config.headers['token'] = token;
	}
	return config;
}, (error) => {
	return Promise.reject(error);
});
axios.interceptors.response.use(
	response => {
//		console.log(response)
		if(response.data.code == '-1') {
			layui.use('layer', () => {
				var layer = layui.layer;
				layer.closeAll();
				layer.msg('登录已过期，请重新登录', {
					icon: 2,
					anim: 6
				})
			})
			setTimeout(function() {
				router.replace('login')
			}, 1500)
		}
		return response;
	},
	error => {

	}
);

export default {
	// 获取验证码
	getCodes(params) {
		let url = 'api/Engineer/getCode'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工程师用户注册
	register(params) {
		let url = 'api/Engineer/register'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 忘记密码
	forgetPwd(params) {
		let url = 'api/Engineer/forgetPwd'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  完善工程师信息 
	fillInfo(params) {
		let url = 'api/Engineer/fillInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 会员中心
	getOrderCountInfo(params) {
		let url = 'api/Engineer/getOrderCountInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取用户注册信息
	getMemberInfo(params) {
		let url = 'api/Engineer/getMemberInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 修改在线状态
	changeOnLineStatus(params) {
		let url = 'api/engineer/changeOnLineStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 登录
	userLogin(params) {
		let url = 'api/Engineer/login'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 修改密码
	editPwd(params) {
		let url = 'api/Engineer/editPwd'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 积分明细-废弃
	getScoreLog(params) {
		let url = 'api/Engineer/getScoreLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},	
	// 等级评分
	getFractionLog(params) {
		let url = 'api/Engineer/getFractionLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},	
	// 工资明细
	getWagesLog(params) {
		let url = 'api/Engineer/getWagesLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},	
	// 任务大厅
	TaskList(params) {
		let url = 'api/Order/eTaskList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 接单
	receiptOrder(params) {
		let url = 'api/Order/eReceiptOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取我的订单
	OrderList(params) {
		let url = 'api/Order/eOrderList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取订单详情
	getOrderDetail(params) {
		let url = 'api/Order/getOrderDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工程师端-保存文件到订单详情
	saveFileUrl(params) {
		let url = 'api/Order/saveFileUrl'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取切割孔数列表
	getHoleList(params) {
		let url = 'api/Order/getHoleList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 完成订单
	finishOrder(params) {
		let url = 'api/Order/efinishOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 提交申诉
	eAppealOrder(params) {
		let url = 'api/Order/eAppealOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 售后订单列表
	eSaleOrderList(params) {
		let url = 'api/Order/eSaleOrderList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取新消息状态
	getNewMsgStatus(params) {
		let url = 'api/Chat/getNewMsgStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取消息列表
	getMsgList(params) {
		let url = 'api/Chat/getMsgList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 发送新消息
	sendMsg(params) {
		let url = 'api/Chat/sendMsg'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取新消息状态-全局
	getAllMsgStatus(params) {
		let url = 'api/Chat/getAllMsgStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取订单时间轴
	getOrderProgress(params) {
		let url = 'api/Order/getOrderProgress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工资明细的明细
	getOrderWages(params) {
		let url = 'api/Engineer/getOrderWages'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//站内公告
	notice(params) {
		let url = '/api/Index/notice'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工程师服务条款》》》》3个端的服务条款
	gcsSecrecy(params) {
		let url = '/api/Index/gcs_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业服务条款》》》》3个端的保密协议
	qySecrecy(params) {
		let url = '/api/Index/qy_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工程师工资协议条款
	gcsWages(params) {
		let url = '/api/Index/gcs_wages'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	
	// 获取评价标签列表 
	getLabelList(params) {
		let url = '/api/Engineer/getLabelList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 评价企业
	addCompanyLabel(params) {
		let url = '/api/Engineer/addCompanyLabel'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题分类
	getQuestionCategory(params) {
		let url = '/api/Question/getQuestionCategory'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题列表
	getQuestionList(params) {
		let url = '/api/Question/getQuestionList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题详情
	getQuestionDetail(params) {
		let url = '/api/Question/getQuestionDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取用户标签属性
	getLabelInfo(params) {
		let url = '/api/Chat/getLabelInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	
	
}


// WEBPACK FOOTER //
// ./src/utils/api.js